import { pickStationTileAnalyticsRowIds, type StationTileAnalyticsRowId } from "@framework/types";

import { IStationTrainAnalyticsRow, IStationTrainDefectIcon, IStationTrainMeasureRow } from "./interfaces";

export interface IStationTrainTileApiDto {
  analytics: Partial<
    Record<
      StationTileAnalyticsRowId,
      {
        parts: Array<{ color?: string; text: string }>;
        rowId: StationTileAnalyticsRowId;
      }
    >
  >;
  defectIcons?: Array<IStationTrainDefectIcon | null>;
  forecastStatus?: number | null;
  hasTciParameters?: boolean;
  idTrain: number;
  measures: Array<{
    alarmStatus: number;
    delta?: number | null;
    measureName: string;
    pointName: string;
    trend?: "down" | "flat" | "up" | null;
    units?: number | null;
    value: number | null;
  }>;
  tciValue?: number | null;
}

export const mapApiTrainTiles = (
  tiles: IStationTrainTileApiDto[] | null | undefined,
  analyticsRowsView: unknown,
  analyticsRowsVisibility?: Record<string, boolean>,
): Record<
  number,
  {
    analyticsRows: IStationTrainAnalyticsRow[];
    defectIcons: Array<IStationTrainDefectIcon | null>;
    forecastStatus: number | null;
    hasTciParameters: boolean;
    measureRows: IStationTrainMeasureRow[];
    tciValue: number | null;
  }
> => {
  if (!tiles?.length) {
    return {};
  }

  const selectedRowIds = pickStationTileAnalyticsRowIds(analyticsRowsView, analyticsRowsVisibility);

  return tiles.reduce<
    Record<
      number,
      {
        analyticsRows: IStationTrainAnalyticsRow[];
        defectIcons: Array<IStationTrainDefectIcon | null>;
        forecastStatus: number | null;
        hasTciParameters: boolean;
        measureRows: IStationTrainMeasureRow[];
        tciValue: number | null;
      }
    >
  >((acc, tile) => {
    acc[tile.idTrain] = {
      analyticsRows: selectedRowIds.map(rowId => tile.analytics[rowId] ?? { rowId, parts: [{ text: "—" }] }),
      defectIcons: tile.defectIcons?.slice(0, 8) ?? [],
      forecastStatus:
        typeof tile.forecastStatus === "number" && !Number.isNaN(tile.forecastStatus) ? tile.forecastStatus : null,
      hasTciParameters: tile.hasTciParameters === true,
      measureRows: tile.measures.map(row => ({
        measureName: row.measureName,
        pointName: row.pointName,
        units: row.units,
        value: row.value,
        delta: row.delta,
        trend: row.trend,
        alarmStatus: row.alarmStatus,
      })),
      tciValue: typeof tile.tciValue === "number" && !Number.isNaN(tile.tciValue) ? tile.tciValue : null,
    };
    return acc;
  }, {});
};
